import React from 'react';
import { motion } from 'framer-motion';
import QuoteWizard from '@/components/shared/QuoteWizard';

export default function InlineContactForm() {
  return (
    <section className="bg-[#0a0a0a] border-t border-white/10 py-16 md:py-20">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="text-center mb-10">
            <div className="w-12 h-px bg-[#C97B2E] mx-auto mb-5" />
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-3">
              Get Your Free Estimate
            </h2>
            <p className="font-body text-white/70 text-base">
              Response within 1 business day — no pressure, just an honest conversation.
            </p>
          </div>

          <div className="bg-white/5 border border-white/10 rounded-sm p-6 md:p-10">
            <QuoteWizard formName="estimate" variant="full" />
          </div>

          <p className="font-body text-white/60 text-sm text-center mt-6">
            Prefer to talk it through?{' '}
            <a
              href="tel:2812037688"
              className="text-[#C97B2E] font-bold hover:text-white transition-colors"
            >
              Call or text Justin at (281) 203-7688
            </a>
          </p>
        </motion.div>
      </div>
    </section>
  );
}
